<template>
  <div class="container" id="container-main">
    <div class="backBtn">
      <b-button type="is-success" rounded @click="GoBack()"><b-icon icon="arrow-left"></b-icon></b-button>
    </div>
    <div v-if="!loading" class="tile">
      <div class="tile is-ancestor">
        <div class="tile is-vertical is-5">
          <div class="tile">
            <div class="tile is-parent">
              <div class="tile is-child notification">
                <div class="wrapper short">
                  <div class="title">Customer Name</div>
                  <div class="customerName">
                    {{ customers[this.customerid].customer_name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="tile is-parent">
              <div class="tile is-child notification">
                <current-conversion-rate v-if="!loading" :stats="stats" :customers="customers"></current-conversion-rate>
              </div>
            </div>
          </div>
          <div class="tile is-parent">
            <div class="tile is-child notification">
              <total-bookings v-if="!loading" :stats="stats" :customers="customers" mode="todayvslastweek"></total-bookings>
            </div>
          </div>
          <div class="tile is-parent">
            <div class="tile is-child notification">
              <conversion-rates v-if="!loading" :stats="stats" :customers="customers"></conversion-rates>
            </div>
          </div>
        </div>
        <div class="tile is-vertical">
          <div class="tile">
            <div class="tile is-parent">
              <div class="tile is-child notification"><total-bookings-today :stats="stats"></total-bookings-today></div>
            </div>
            <div class="tile is-parent">
              <div class="tile is-child notification"><historic-bookings :customerid="this.customerid" :period="30" :timeframe="'days'"></historic-bookings></div>
            </div>
            <div class="tile is-parent">
              <div class="tile is-child notification"><historic-bookings :customerid="this.customerid" :period="1" :timeframe="'year'"></historic-bookings></div>
            </div>
          </div>
          <div class="tile is-parent">
            <div class="tile is-child notification">
              <outcomes-circle :stats="stats"></outcomes-circle>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-loading v-model="loading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
const axios = require("axios");
const dayjs = require("dayjs");
import TotalBookings from "./charts/TotalBookings.vue";
import ConversionRates from "./charts/ConversionRates.vue";
import CurrentConversionRate from "./charts/CurrentConversionRate.vue";
import CallsChart from "./charts/CallsChart.vue";
import TotalBookingsToday from "./charts/TotalBookingsToday.vue";
import OutcomesCircle from "./charts/OutcomeCircle.vue";
import HistoricBookings from "./charts/HistoricBookings.vue";
export default {
  components: {
    TotalBookings,
    ConversionRates,
    CurrentConversionRate,
    CallsChart,
    TotalBookingsToday,
    OutcomesCircle,
    HistoricBookings,
  },
  data: function () {
    return {
      apiUrl: "https://api.jeak.co.uk",
      stats: [],
      customers: {},
      loading: true,
      backgroundTimer: {},
      lastRefresh: "",
      nextRefresh: "",
    };
  },
  props: {
    customerid: {
      type: String,
      required: true,
    },
  },
  methods: {
    GetItems: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      let fromDate = dayjs().subtract(14, "day").format();
      let toDate = dayjs().format();
      await this.GetCustomers();
      axios.get(this.apiUrl + `/stats/dashboard/${this.customerid}?from=${fromDate}&to=${toDate}`, config).then((response) => {
        this.loading = false;
        this.stats = response.data;
        this.lastRefresh = dayjs().format("hh:mm");
        this.nextRefresh = dayjs().add(1, "hour").format("hh:05");
      });
    },
    GetCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(this.apiUrl + "/customers", config);
      response.data.forEach((customer) => {
        this.customers[customer.disctools_id] = customer;
      });
    },
    GoBack: async function () {
      this.$router.push("/voiceplus/dashboard");
    },
    SetTimer: async function () {
      this.backgroundTimer = setInterval(() => {
        if (dayjs().isAfter(this.nextRefresh)) {
          this.GetItems();
        }
      }, 60000);
    },
  },
  mounted() {
    this.GetItems();
    this.SetTimer();
  },
};
</script>

<style scoped>
.container {
  max-width: unset !important;
  width: 100%;
  padding: 10px;
}
.notification.is-info {
  background-color: #3e8ed0;
  color: #fff;
}
#container-main {
  position: relative;
}
.backBtn {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}
.wrapper {
  display: grid;
  grid-template-rows: 1fr 20fr;
  grid-template-columns: 1fr;
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
}
.customerName {
  display: flex;
  font-size: 3em;
  justify-content: center;
  align-items: center;
}
.short {
  height: 150px;
}
.tall {
  height: 450px;
}
</style>
